import { ReactNode, useMemo } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import {
  IconSavedPenal,
  IconCaptain,
  IconFigure,
  IconGol,
  IconGolPenal,
  IconWrongPenal,
  IconGolRecibed,
  IconVisitor,
  IconDontAdd,
  IconInvictus,
  IconSelfGol,
  IconGoldendGol,
} from './Icons';
import { IconCard } from './Icons/IconCard';

import { MyPlayersScore } from '@/types/fieldAssistance';

export interface IconPlayerIncidents {
  icon: ReactNode | null;
  text?: string | number;
  textTooltip?: string | number;
  id: number;
}

interface IconProps {
  variant?: MyPlayersScore;
  textTooltip?: string | number;
  text?: string | number;
  id?: string | number;
}
export const IconPlayerIncidents = ({
  variant,
  textTooltip,
  text,
  id,
}: IconProps) => {
  const icon = useMemo(() => {
    if (variant?.goles === Infinity) {
      return {
        id,
        icon: <IconGol />,
        textTooltip,
        text,
      };
    } else if (variant?.golesPenal === Infinity) {
      return {
        id,
        icon: <IconGolPenal />,
        textTooltip,
        text,
      };
    } else if (variant?.golesEnContra === Infinity) {
      return {
        id,
        icon: <IconSelfGol />,
        textTooltip,
        text,
      };
    } else if (variant?.tarjetaRoja) {
      return {
        id,
        icon: (
          <IconCard
            bgColor="bg-gdt-status-red-light"
            color="text-gdt-status-red"
          />
        ),
        textTooltip,
      };
    } else if (variant?.tarjetaAmarilla) {
      return {
        id,
        icon: (
          <IconCard
            bgColor="bg-gdt-status-yellow-light"
            color="text-gdt-status-yellow"
          />
        ),
        textTooltip,
      };
    } else if (variant?.figura) {
      return {
        id,
        icon: <IconFigure />,
        textTooltip,
      };
    } else if (variant?.penalesAtajados === Infinity) {
      return {
        id,
        icon: <IconSavedPenal />,
        textTooltip,
        text,
      };
    } else if (variant?.penalesErrados === Infinity) {
      return {
        id,
        icon: <IconWrongPenal />,
        textTooltip,
        text,
      };
    } else if (variant?.golesRecibidos === Infinity) {
      return {
        id,
        icon: <IconGolRecibed />,
        textTooltip,
        text,
      };
    } else if (variant?.golesVisitante === Infinity) {
      return {
        id,
        icon: <IconVisitor />,
        textTooltip,
        text,
      };
    } else if (variant?.jugo) {
      return {
        id,
        icon: (
          <div className="mt-[-2px]">
            <IconDontAdd />
          </div>
        ),
        textTooltip,
        text,
      };
    } else if (variant?.asegurado) {
      return {
        id,
        icon: (
          <span className="flex items-center justify-center h-7 w-7 rounded-full bg-gdt-white text-gdt-blue font-bold text-xs leading-none">
            A
          </span>
        ),
        textTooltip: `${textTooltip || 0}`,
        text,
      };
    } else if (variant?.vallaInvicta) {
      return {
        id,
        icon: <IconInvictus />,
        textTooltip,
      };
    } else if (variant?.golDeOro) {
      return {
        id,
        icon: <IconGoldendGol />,
        textTooltip,
        text,
      };
    } else if (variant?.isCapitan) {
      return {
        id,
        icon: <IconCaptain />,
        textTooltip: `${textTooltip || 0}`,
      };
    }
  }, [variant, textTooltip, text, id]);

  return (
    <>
      <span
        className="relative"
        data-tooltip-id={`tooltip-${icon?.id}`}
        role="status"
      >
        <figure className="h-7 w-7">{icon?.icon}</figure>
        {icon?.text && (
          <p className="text-white bg-black pacity rounded-full absolute -bottom-[4px] -right-[4px] text-4xs font-light flex w-[13px] h-[13px] items-center justify-center shadow-lg">
            {icon.text}
          </p>
        )}
      </span>
      {icon?.textTooltip && icon.textTooltip !== '' && (
        <ReactTooltip
          content={`${icon?.textTooltip}`}
          id={`tooltip-${icon.id}`}
          style={{
            backgroundColor: 'black',
            fontWeight: 700,
            padding: '2px 8px',
            lineHeight: '1',
            fontSize: '.6rem',
            color: 'white',
          }}
        />
      )}
    </>
  );
};
